import { ReactNode } from "react";
import { Accordion } from "@mantine/core";

interface FilterSectionProps {
  /** Identifies the section for FilterPanel's `defaultOpen` */
  value: string;
  title: string;
  children: ReactNode;
}

/** One collapsible section of a FilterPanel. */
export default function FilterSection({ value, title, children }: FilterSectionProps) {
  return (
    <Accordion.Item value={value}>
      <Accordion.Control>{title}</Accordion.Control>
      <Accordion.Panel>{children}</Accordion.Panel>
    </Accordion.Item>
  );
}
